<div
    class="pause px-1 text-center fw-bold"
    [class.invalid]="hasTooManyRegisteredMinutes"
    [matTooltip]="
        hasTooManyRegisteredMinutes
            ? 'Meer dan 12 uur geregistreerd'
            : 'Totaal aantal uren medewerker of materieelstuk op deze dag'
    ">
    <i class="fa-clock" [class.far]="!hasTooManyRegisteredMinutes" [class.fas]="hasTooManyRegisteredMinutes"></i>
    <br />

    @if (userId()) {
        {{ userRegisteredMinutes() | minutes }}
    } @else {
        {{ entityRegisteredMinutes() | minutes }}
    }
</div>
